/**
 * Created by afuhr on 20.09.2016.
 */
import {IPayloadAction} from "../../actions";
import {SessionActions} from "../../actions/session.actions";
import {ISessionRecord, Message} from "./session.types";
import {
  AdminUnitFactory,
  INITIAL_ADMIN_UNIT_STATE,
  INITIAL_STATE,
  INITIAL_USER_STATE,
  MessageFactory,
  UserFactory
} from "./session.initial-state";
import {List} from "immutable";
import {AdminUnitActions} from "../../actions/admin-unit.actions";


export function sessionReducer(state: ISessionRecord = INITIAL_STATE,
                               action: IPayloadAction): ISessionRecord {

  let messages: List<Message> = List<Message>(state.messages);

  switch (action.type) {
    case SessionActions.LOGIN_USER:
      return state.merge({
        token: null,
        loggedIn: false,
        user: INITIAL_USER_STATE,
        hasError: false,
        isLoading: true,
      });

    case SessionActions.LOGIN_USER_SUCCESS:
      return state.merge({
        loggedIn: true,
        user: UserFactory(action.payload.profile),
        activeAdminUnit: action.payload.profile.administration_units[0].cuid,
        hasError: false,
        isLoading: false,
      });

    case SessionActions.LOGIN_USER_ERROR:
      return state.merge({
        token: null,
        loggedIn: false,
        user: INITIAL_USER_STATE,
        hasError: true,
        isLoading: false,
      });

    case SessionActions.LOGOUT_USER:
      return INITIAL_STATE;

    case AdminUnitActions.SELECT_ADMIN_UNIT:
      return state.merge({
        activeAdminUnit: action.payload.cuid
      });

    case AdminUnitActions.RETRIEVE_ADMIN_UNIT_DATA:
      return state;
    // Don't remove existing data in redux store, when loading the active admin unit data
    /*.merge({
      activeAdminUnitData: INITIAL_ADMIN_UNIT_STATE
    });*/

    case AdminUnitActions.RETRIEVE_ADMIN_UNIT_DATA_SUCCESS:
      return state.merge({
        activeAdminUnitData: AdminUnitFactory(action.payload)
      });

    case AdminUnitActions.RETRIEVE_ADMIN_UNIT_DATA_ERROR:
      return state.merge({
        activeAdminUnitData: INITIAL_ADMIN_UNIT_STATE
      });


    case SessionActions.INIT_ASYNC_ACTION:
      return state.merge({
        isLoading: true
      });

    case SessionActions.FINISH_ASYNC_ACTION:
      return state.merge({
        isLoading: false
      });

    case SessionActions.REFRESH_TOKEN:
      return state.merge({
        token: action.payload
      });

    case SessionActions.SET_REDIRECT_URL:
      return state.merge({
        redirectUrl: action.payload
      });

    // Messages
    case SessionActions.PUSH_MESSAGE:
      let newState = messages.push(MessageFactory(action.payload));
      return state.merge({
        messages: newState
      });

    case SessionActions.CLEAR_ALL_MESSAGES:
      return state.merge({
        messages: List<Message>()
      });

    case SessionActions.REMOVE_MESSAGE:
      return state.merge({
        messages: messages.remove(action.payload)
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/redux-store/session/session.reducer.ts